export default {
  首页: "Hem",
  资产: "Tillgångar",
  币币: "Spot",
  快捷买币: "Snabbköp av krypto",
  "支持多种方式购买，购买更简单": "Köp enkelt med flera betalningsmetoder",
  语言设置: "Språkinställningar",
  确认恢复: "Bekräfta återställning",
  "输入邮箱，方便我们联系您":
    "Ange din e-postadress så att vi kan kontakta dig",
  划转: "Överför",
  行情: "Marknad",
  "24H成交": "24h volym",
  累计收益: "Total avkastning",
  充值时间: "Insättningsdatum",
  到期时间: "Förfallodatum",
  数量: "Antal",
  操作: "Åtgärd",
  资产信息: "Tillgångsinformation",
  复制地址: "Kopiera adress",
  链名称: "Kedjenamn",
  充值地址: "Insättningsadress",
  收款地址: "Mottagaradress",
  账单: "Faktura",
  提现金额: "Uttagsbelopp",
  接收地址: "Mottagaradress",
  交易密码: "Handelslösenord",
  提现全部: "Ta ut allt",
  保存图片: "Spara bild",
  输入您的交易密码: "Ange ditt handelslösenord",
  确定: "Bekräfta",
  地址: "Adress",
  注册时间: "Registreringsdatum",
  取消: "Avbryt",
  是否划转: "Överför?",
  登录: "Logga in",
  我的地址: "Mina adresser",
  登录密码和交易密码: "Inloggningslösenord och handelslösenord",
  注册: "Registrera",
  密码: "Lösenord",
  设置密码: "Ange lösenord",
  重复密码: "Upprepa lösenord",
  新密码: "Nytt lösenord",
  确认新密码: "Bekräfta nytt lösenord",
  充值: "Sätt in",
  充值货币: "Sätt in valuta",
  合约账户充值: "Sätt in på terminskonto",
  账户充值: "Sätt in på konto",
  其他: "Annat",
  我的邀请码: "Min inbjudningskod",
  提现: "Ta ut",
  客服: "Kundservice",
  持有详情: "Innehavsdetaljer",
  请输入内容: "Ange innehåll",
  邀请好友来领取奖励: "Bjud in vänner och få belöningar",
  复制链接: "Kopiera länk",
  重复设置新的密码: "Upprepa nytt lösenord",
  保存: "Spara",
  我的: "Mitt konto",
  "邮箱/手机号": "E-post/Mobilnummer",
  备注: "Anmärkning",
  地址管理: "Adresshantering",
  我的团队: "Mitt team",
  联系我们: "Kontakta oss",
  竭诚为您服务: "Vi står till din tjänst",
  提取收益: "Ta ut avkastning",
  带给我的收益: "Genererad avkastning",
  添加: "Lägg till",
  名称: "Namn",
  添加地址: "Lägg till adress",
  修改地址: "Ändra adress",
  可提现: "Uttagbar",
  安全中心: "Säkerhetscenter",
  收益划转: "Överför avkastning",
  通知中心: "Aviseringar",
  "累计收益:": "Total avkastning:",
  注册用户: "Registrerade användare",
  奖励规则: "Belöningsregler",
  帮助反馈: "Hjälp och feedback",
  邀请好友: "Bjud in vänner",
  恢复身份: "Återställ identitet",
  选择语言: "Välj språk",
  设置新的密码: "Ange nytt lösenord",
  暂无活动: "Inga aktiva aktiviteter",
  "月增长量(+)": "Månatlig tillväxt (+)",
  可提取: "Uttagbar",
  反馈类型: "Feedbacktyp",
  赠送: "Gåva",
  已经复制: "Kopierad",
  保存成功: "Sparad",
  划转成功: "Överföring lyckades",
  过期: "Utgången",
  提交成功: "Inskickad",
  "服务器繁忙，稍后在试": "Servern är upptagen, försök igen senare",
  全部: "Alla",
  一级: "Nivå 1",
  二级: "Nivå 2",
  三级: "Nivå 3",
  级: "Nivå",
  删除成功: "Raderad",
  选择地址: "Välj adress",
  不再提醒: "Visa inte igen",
  "最小充值金额：": "Minsta insättningsbelopp:",
  选择币种: "Välj kryptovaluta",
  输入投资金额: "Ange investeringsbelopp",
  输入账户密码: "Ange kontolösenord",
  投资: "Investera",
  订单编号: "Ordernummer",
  投资周期: "Investeringsperiod",
  投资资金: "Investerat belopp",
  投资时间: "Investeringstidpunkt",
  状态: "Status",
  投资中: "Aktiv",
  已到期: "Utgången",
  暂无数据: "Inga data",
  转入: "Överför till",
  邮箱: "E-post",
  请输入邮箱: "Ange e-postadress",
  请输入格式正确的邮箱: "Ange en giltig e-postadress",
  请输入验证码: "Ange verifieringskod",
  获取验证码: "Hämta verifieringskod",
  请输入邀请码: "Ange inbjudningskod",
  今天: "Idag",
  昨天: "Igår",
  最近七天: "Senaste 7 dagarna",
  邀请: "Bjud in",
  购买数量: "Köpmängd",
  产品详情: "Produktdetaljer",
  币种: "Kryptovaluta",
  利息币种: "Avkastningsvaluta",
  理财类型: "Typ av finansprodukt",
  产品费率: "Produktavgifter",
  进行中: "Aktiv",
  每天: "Dagligen",
  请输入搜索关键词: "Ange sökord",
  通知: "Aviseringar",
  查看更多: "Se mer",
  理财宝: "Finansprodukter",
  周期: "Löptid",
  年利率: "Årlig ränta (APY)",
  更多产品: "Fler produkter",
  灵活存取: "Flexibelt sparande",
  稳定收益: "Stabil avkastning",
  合约指南: "Terminsguide",
  资金划转出: "Utgående överföring",
  矿池收益: "Gruvbelöning",
  提现手续费: "Uttagsavgift",
  冻结资金: "Frysta medel",
  解冻资金: "Frigör frysta medel",
  闪兑支出: "Kostnad för snabbväxling",
  闪兑收入: "Intäkt från snabbväxling",
  闪兑手续费: "Avgift för snabbväxling",
  合约支出: "Terminskostnad",
  合约收入: "Terminsintäkt",
  输入的金额不可大于可用金额: "Beloppet får inte överstiga tillgängligt belopp",
  全部兑换成功: "Fullständig växling lyckades",
  返回: "Tillbaka",
  查看历史: "Visa historik",
  闪兑历史: "Historik för snabbväxling",
  支付: "Betala",
  获取: "Få",
  时间: "Tid",
  手续费: "Transaktionsavgift",
  折扣: "Rabatt",
  价格: "Pris",
  逐仓: "Isolerad marginal",
  全仓: "Kryssmarginal",
  市价委托: "Marknadsorder",
  限价委托: "Limitorder",
  请输入本金: "Ange kapitalbelopp",
  请输入价格: "Ange pris",
  "可做空/做多": "Möjligt att korta/longa",
  设置止盈止损: "Ställ in take-profit/stop-loss",
  止盈价: "Take-profit pris",
  止损价: "Stop-loss pris",
  成本: "Kostnadspris",
  做多: "Long",
  做空: "Short",
  仓位信息: "Positionsinformation",
  一键平仓: "Stäng position (ett klick)",
  永续: "Perpetual",
  浮动盈亏: "Orealiserad vinst/förlust",
  平仓: "Stäng position",
  反向开仓: "Öppna omvänd position",
  一键撤销: "Avbryt alla (ett klick)",
  倍杠杆: "x hävstång",
  执行价格: "Verkställningspris",
  委托数量: "Orderkvantitet",
  保证金: "Marginal",
  成交价: "Verkställningspris",
  创建时间: "Skapelsetid",
  撤销: "Avbryt",
  合约市场: "Terminsmarknad",
  交易方向: "Handelsriktning",
  委托价格: "Orderpris",
  委托金额: "Orderbelopp",
  资金费率: "Finansieringsränta",
  "多方和空方交易者支付的定期费用，每8小时结算一次。":
    "Periodisk avgift som betalas av långa och korta positioner, avräknas var 8:e timme.",
  "资金费率为正，多方向空方支付资金费用。":
    "Med positiv finansieringsränta betalar långa positioner till korta positioner.",
  "资金费率为负，空方向多方支付资金费用。":
    "Med negativ finansieringsränta betalar korta positioner till långa positioner.",
  "确定反向开仓吗？反向开仓将以当期相反 的仓位进行买入":
    "Är du säker på att du vill öppna en omvänd position? Detta kommer att köpa motsatt riktning av din nuvarande position.",
  "仓位止盈/止损": "Take-profit/Stop-loss för position",
  合约名称: "Terminskontrakt",
  开仓价格: "Öppningspris",
  指数价格: "Indexpris",
  止盈设置: "Take-profit-inställningar",
  请输入止盈价: "Ange take-profit-pris",
  "当指数价格触达*时，将会触发委托平仓":
    "När indexpriset når * kommer en stängningsorder att utlösas.",
  预计盈亏: "Förväntad vinst/förlust",
  当前仓位: "Nuvarande position",
  平仓金额: "Stängningsbelopp",
  仓位模式: "Positionsläge",
  全仓模式: "Kryssmarginläge",
  "合约账户中的所有可用资金视作为可用保证金， 当仓位亏损超过了账户余额才会爆仓强平，并将损失所有 保证金和仓位，请注意":
    "I kryssmarginläge används alla tillgängliga medel på ditt terminskonto som marginal. Likvidation sker när förlusten överstiger ditt totala saldo, vilket resulterar i förlust av hela din marginal och position.",
  逐仓模式: "Isolerat marginalläge",
  "会使合约账户中的一定数量保证金被分配到仓位上。如果保证金亏损低于维持保证金的水平，仓位被强平。在逐仓模式下，您可以为这个仓位增加和减少保证金。":
    "En specifik mängd marginal tilldelas en position. Om marginalförlusten faller under underhållsmarginalnivån, likvideras positionen. Du kan öka eller minska marginalen för denna position.",
  "是否撤销？": "Avbryt order?",
  "是否一键撤销？": "Avbryt alla ordrar?",
  "是否一键平仓？": "Stäng alla positioner?",
  持仓保证金: "Marginal för nuvarande position",
  风险率: "Riskprocent",
  未实现盈亏: "Orealiserad vinst/förlust",
  可用保证金: "Tillgänglig marginal",
  净值: "Netto värde",
  账户余额: "Kontosaldo",
  合约计算器: "Terminskalkylator",
  交易记录: "Transaktionshistorik",
  "*倍杠杆": "*x hävstång",
  "平仓盈亏：": "Stängd vinst/förlust:",
  时间筛选: "Tidsfilter",
  仓位类型: "Positionstyp",
  订单状态: "Orderstatus",
  订单类型: "Ordertyp",
  平仓价格: "Stängningspris",
  持仓数量: "Positionskvantitet",
  "手续费(%)": "Transaktionsavgift (%)",
  平仓时间: "Stängningstid",
  平仓类型: "Stängningstyp",
  手动平仓: "Manuell stängning",
  强制平仓: "Tvångslikvidation",
  近1天: "Senaste dagen",
  近7天: "Senaste 7 dagarna",
  近30天: "Senaste 30 dagarna",
  近180天: "Senaste 180 dagarna",
  持仓: "Öppen position",
  已取消: "Avbruten",
  分时: "Intradag",
  "24H额(USDT)": "24h volym (USDT)",
  "24H低": "24h låg",
  "24H量(BTC)": "24h volym (BTC)",
  "24H高": "24h hög",
  "10秒": "10 sekunder",
  "30秒": "30 sekunder",
  "1分": "1 minut",
  "3分": "3 minuter",
  "5分": "5 minuter",
  "30分": "30 minuter",
  "1小时": "1 timme",
  "4小时": "4 timmar",
  "8小时": "8 timmar",
  "1天": "1 dag",
  "1周": "1 vecka",
  "1月": "1 månad",
  单向持仓: "Enkelriktad position",
  杠杆: "Hävstång",
  仓位: "Position",
  计算结果: "Resultat",
  盈亏: "Vinst/Förlust",
  收益率: "Avkastning",
  计算结果仅供参考: "Resultatet är vägledande",
  成交后仓位大小: "Positionens storlek efter verkställande",
  "计算结果仅供参考,实际结果可能因费率差异":
    "Resultatet är vägledande, faktiska resultat kan variera på grund av avgifter.",
  目标价格: "Målpris",
  开始计算: "Beräkna",
  强平价格: "Likvideringspris",
  "充值前，请认真核对充值的链名称，充值错误无法找回资产*最小充值金额为*；少于此金额平台将无法确认到账，请不要向此地址充值*之外的资产，否则将无法找回资产，请不要直接提现众筹或者ICO地址，平台不会代理币的发放。":
    "Kontrollera kedjenamnet noggrant före insättning. Felaktiga insättningar kan inte ångras. Minsta insättningsbelopp är *. Insättningar under detta belopp kommer inte att behandlas. Skicka inte andra tillgångar till denna adress. Använd inte ICO- eller crowdfunding-adresser för uttag.",
  "最小输入*": "Minimum {0}",
  "最小提币数量为*，提币手续费将从你的提款金额中扣除。提币前请确认核对收款地址，不要将*提现至*以外的地址，否则无法找回资产。请不要直接提现众筹或者ICO地址，平台不会处理代币的发放。":
    "Minsta uttagsmängd är *. Uttagsavgifter kommer att dras från uttagsbeloppet. Kontrollera mottagaradressen noggrant. Skicka inte * till adresser utanför *. Använd inte ICO- eller crowdfunding-adresser.",
  退出登录: "Logga ut",
  加仓: "Öka position",
  新增仓位: "Ny position",
  输入加仓金额: "Ange belopp för att öka positionen",
  "当前可用:": "Nu tillgängligt:",
  资产账单: "Tillgångsfaktura",
  保存二维码: "Spara QR-kod",
  温馨提示: "Observera",
  "请注意：您当前使用的网络": "Observera: Du använder för närvarande nätverket",
  输入提现地址: "Ange uttagsadress",
  "可用金额：": "Tillgängligt belopp:",
  输入资产密码: "Ange tillgångslösenord",
  可用手续费: "Tillgänglig avgift",
  "折扣%": "Rabatt %",
  实扣手续费: "Faktiskt debiterad avgift",
  实际到账: "Faktiskt mottaget belopp",
  未设置资产密码: "Tillgångslösenord inte angivet",
  "为了您的资产安全，请设置资产密码后再来提现。":
    "För din säkerhet, ange ett tillgångslösenord innan du gör uttag.",
  热榜: "Populärt",
  涨幅榜: "Största ökningar",
  跌幅榜: "Största fall",
  成交额榜: "Volymranking",
  关于我们: "Om oss",
  登录密码: "Inloggningslösenord",
  设置: "Inställningar",
  资产密码: "Tillgångslösenord",
  修改登录密码: "Ändra inloggningslösenord",
  原密码: "Gammalt lösenord",
  请输入新密码: "Ange nytt lösenord",
  请输入原密码: "Ange gammalt lösenord",
  确认密码: "Bekräfta lösenord",
  确定修改: "Bekräfta ändring",
  修改资产密码: "Ändra tillgångslösenord",
  验证码: "Verifieringskod",
  资产密码使用提示: "Tips för tillgångslösenord",
  "资产密码用于转移、提取资产和交易。":
    "Tillgångslösenord används för att överföra, ta ut och handla tillgångar.",
  "创建与登录密码不同的资产密码。":
    "Skapa ett tillgångslösenord som skiljer sig från inloggningslösenordet.",
  "定期更改您的资产密码。": "Ändra ditt tillgångslösenord regelbundet.",
  提币历史: "Uttagshistorik",
  "金额/余额": "Belopp/Saldo",
  "手续费/折扣": "Avgift/Rabatt",
  自选: "Favoriter",
  现货: "Spot",
  市价: "Marknadspris",
  止损设置: "Stop-loss-inställningar",
  合约K线图: "Terminsdiagram",
  "24H量": "24h volym",
  "24H额": "24h volym (USDT)",
  合作指南: "Partnerguide",
  盈亏计算: "Beräkning av vinst/förlust",
  当前可用: "Nu tillgängligt",
  请输入加仓金额: "Ange belopp för att öka positionen",
  请重新输入加仓金额: "Ange beloppet för att öka positionen igen",
  平仓数量: "Antal att stänga",
  欢迎登录: "Välkommen tillbaka",
  "忘记密码?": "Glömt lösenord?",
  "还没有账号？": "Har du inget konto?",
  立即注册: "Registrera dig nu",
  繁體中文: "Traditionell kinesiska",
  找回密码: "Återställ lösenord",
  下一步: "Nästa",
  注册账户: "Registrera konto",
  "请输入邀请码(选填)": "Ange inbjudningskod (valfritt)",
  谢邀豪礼: "Inbjudningsbonus",
  "24小时邀请好友排名": "24-timmars inbjudningsranking",
  "*人": "* personer",
  "差*人": "Saknar * personer",
  "已超过10万人，每月轻松赚钱":
    "Över 100 000 användare, tjäna pengar enkelt varje månad",
  最高: "Max",
  邀请链接: "Inbjudningslänk",
  "平台和您共享好友在平台（现货、合约、杠杆、闪兑）所产生的手续费":
    "Dela i transaktionsavgifterna som genereras av dina vänner (spot, terminer, marginal, snabbväxling).",
  平台和您一起分享手续费: "Dela transaktionsavgifterna med plattformen",
  "*级": "* nivå",
  规则: "Regler",
  我的好友: "Mina vänner",
  好友详情: "Väninformation",
  获得好友佣金方案: "Vänprovisionsplan",
  我的等级: "Min nivå",
  我的邀请数据: "Mina inbjudningsstatistik",
  当前等级: "Nuvarande nivå",
  平台奖励您: "Plattformsbelöning till dig",
  最高可获取平台奖励: "Maximal plattformsbelöning",
  邀请规则: "Inbjudningsregler",
  "邀请*级有效好友": "Bjud in aktiva vänner på nivå *",
  好友等级: "Vännivå",
  人: "personer",
  奖金派送: "Bonusutbetalning",
  平台奖励: "Plattformsbelöning",
  "最终解释权归平台所有，若发现异常获取平台奖励，将会扣除所有的奖励，并且冻结账户，资产的损失将无法找回。":
    "Plattformen har rätt till slutlig tolkning. Vid bedrägliga aktiviteter kommer belöningar att dras tillbaka och ditt konto frysas. Förlorade tillgångar kan inte återvinnas.",
  "您的账户必须是有效账户，平台判定有效账户条件为（账户充值任何币种）最小* USDT的价值。":
    "Ditt konto måste vara aktivt, definierat som en insättning av minst * USDT i valfritt kryptovaluta.",
  "您邀请的好友，必须是有效下级，平台判定有效下级为（账户充值任何币种）最小* USDT的价值。":
    "Din inbjudna vän måste vara en aktiv nedlinje, definierad som en insättning av minst * USDT i värde.",
  "邀请人和被邀请者的账号不能同属于一个IP。":
    "Inbjudaren och den inbjudna får inte dela samma IP-adress.",
  "VIP等级由您邀请的*级好友的人数作为考核。":
    "VIP-nivå bestäms av antalet inbjudna vänner på nivå *.",
  佣金成分: "Provisionskomponenter",
  收益统计: "Avkastningsstatistik",
  昨日收益: "Gårdagens avkastning",
  月收益: "Månatlig avkastning",
  获取收益: "Få avkastning",
  "总收益：": "Total avkastning:",
  "*级好友": "Vänner på nivå *",
  理财购买: "Köp finansprodukt",
  期限: "Löptid",
  可用金额: "Tillgängligt belopp",
  预估收益: "Beräknad avkastning",
  申购上限: "Maximalt köp",
  项目剩余: "Återstående projekt",
  "买入后预计*(SGT)开始计算收益。":
    "Avkastning förväntas börja löpa cirka *(SGT) efter köp.",
  计息日: "Räntestartdatum",
  申购日: "Köpsdatum",
  到账日: "Krediteringsdatum",
  到期自动续投: "Automatisk återinvestering vid förfall",
  申购: "Köp",
  搜索理财项目: "Sök finansprodukt",
  超高年化随心选: "Välj bland produkter med hög avkastning",
  "自由选择理财币种，稳定超额收益":
    "Välj fritt din kryptovaluta för stabil, över genomsnittet avkastning",
  理财总资产: "Totalt investerade tillgångar",
  申购数量: "Kvantitet att köpa",
  立即购买: "Köp nu",
  年化收益率: "Årlig procentuell avkastning (APY)",
  理财订单: "Finansproduktorder",
  持有: "I besittning",
  申购份额: "Köpt andel",
  到账日期: "Krediteringsdatum",
  申购成功: "Köp lyckades",
  到期: "Utgången",
  是否选择做多: "Öppna long-position?",
  "可用余额为0 不能操作": "Saldo är 0, åtgärd inte möjlig",
  福利中心: "Bonuscenter",
  奖励记录: "Belöningshistorik",
  我获取到的奖励: "Mina intjänade belöningar",
  总价值: "Totalt värde",
  新手任务: "Uppgifter för nya användare",
  身份认证: "Identitetsverifiering (KYC)",
  身份验证: "Identitetsverifiering",
  去验证: "Verifiera nu",
  审核中: "Under behandling",
  已验证: "Verifierad",
  认证失败: "Verifiering misslyckades",
  基础认证: "Grundläggande verifiering",
  "请注意认证信息一经验证不能修改，务必填写准确信息":
    "Observera: Verifierad information kan inte ändras. Ange korrekta uppgifter.",
  "国家/地区": "Land/Region",
  请选择: "Välj",
  证件类型: "Dokumenttyp",
  证件编码: "Dokumentnummer",
  身份证: "ID-kort",
  护照: "Pass",
  驾驶证: "Körkort",
  请输入编码: "Ange nummer",
  名字: "Förnamn",
  请输入: "Ange",
  中间名: "Mellannamn",
  选填: "Valfritt",
  姓氏: "Efternamn",
  中国: "Kina",
  身份上传: "Ladda upp identitetsdokument",
  上传身份证: "Ladda upp ID-kort",
  "以上材料需要用JPG/JPEG/PNG格式上传，并且保证照片的清晰边角完整，亮度均匀。且大小不超过*M。":
    "Ladda upp i JPG/JPEG/PNG-format. Se till att bilderna är tydliga, kompletta och jämnt belysta. Maximalt *MB.",
  确定提交: "Skicka",
  去认证: "Verifiera",
  挑战任务: "Utmaningsuppgifter",
  注册认证任务: "Registrerings- och verifieringsuppgift",
  完成注册认证即可领取: "Slutför registrering och verifiering för att få",
  领取奖励: "Motta belöning",
  新人豪礼: "Välkomstbonus",
  "参与人数：": "Antal deltagare:",
  条件: "Villkor",
  入金量: "Insättningsbelopp",
  完成: "Slutförd",
  任务奖励: "Uppgiftsbelöning",
  距任务更新: "Till uppgiftsuppdatering",
  "条件：": "Villkor:",
  活动规则: "Aktivitetsregler",
  奖励明细: "Belöningsdetaljer",
  已获得: "Förvärvad",
  交易奖励: "Handelsbelöning",
  Win奖励: "WIN-belöning",
  已领取: "Mottagen",
  亏损金额超过: "Förlustbelopp överstiger",
  单笔开仓金额超过: "Enskilt orderbelopp överstiger",
  交易量: "Handelsvolym",
  待完成: "Väntande",
  入金: "Insättning",
  盈利金额超过: "Vinstbelopp överstiger",
  开仓金额: "Orderbelopp",
  开仓金: "Orderbelopp",
  盈利: "Vinst",
  亏损: "Förlust",
  领取: "Motta",
  未领取: "Ej mottagen",
  待领取: "Väntar på mottagning",
  再交易: "Handla vidare",
  即可获得: "för att få",
  领取成功: "Mottagen",
  "1、所有的活动都会按照活动最后的时间进行统计收益过期后将无效。":
    "1. Alla aktiviteter kommer att avräknas på slutdatumet. Belöningar löper ut efter detta.",
  "2、获得的收益会发放到您的赏金账户中，你可以随时根据您的需要进行兑换和提现。":
    "2. Intjänad avkastning kommer att krediteras ditt bonus-konto, som du kan växla eller ta ut när som helst.",
  "3、获取的到的奖励币种类型根据任务按类型发放。":
    "3. Belöningskryptovalutan beror på uppgiften.",
  "4、最终解释权归平台所有，若发现存在异常手段套利平台的任务奖金，平台有权冻结并且清除您获取的收益。":
    "4. Plattformen har rätt till slutlig tolkning. Vid fusk med uppgifter kommer belöningar att hållas tillbaka och ditt konto kan frysas.",
  成长学院: "Akademi",
  "区块链 & 加密货币": "Blockkedja & Kryptovaluta",
  "您的加密货币一站式指南，我们带您开启加密货币之路。":
    "Din kompletta guide till kryptovaluta. Vi följer dig på din kryptoresa.",
  "全仓合约定单的全部保证金。": "Total marginal för kryssmargin terminsorder.",
  "(账户余额+(浮动盈亏-手续费-过夜费)=净值/已用保证金*100":
    "(Saldo + (orealiserad vinst/förlust - avgifter - finansieringsräntor) = Netto värde / Använd marginal * 100",
  "浮动盈亏会直接影响”可用保证金“，当未实现盈亏增加，可用保证金将会增加，未实现盈亏减少，可用保证金同样也会减少。":
    "Orealiserad vinst/förlust påverkar direkt 'tillgänglig marginal'. Om orealiserad vinst/förlust ökar, ökar tillgänglig marginal och vice versa.",
  "账户余额-(已用保证金)+(浮动盈亏-手续费-过夜费)":
    "Saldo - (Använd marginal) + (orealiserad vinst/förlust - avgifter - finansieringsräntor)",
  "注:可继续用于开仓的保证金。":
    "Obs: Marginal som är tillgänglig för att öppna nya positioner.",
  "账户余额+(浮动盈亏-手续费-过夜费)":
    "Saldo + (orealiserad vinst/förlust - avgifter - finansieringsräntor)",
  "注:当前的资金结余。": "Obs: Nuvarande saldo.",
  "指的是合约账户的全部余额，包含不可用余额。":
    "Avser totalt saldo på terminskontot, inklusive frysta belopp.",
  "注:风险率越高，风险越低，风险率越低，风险越高。":
    "Obs: Ju högre riskprocent, desto lägre risk, och vice versa.",
  该功能尚未开发: "Denna funktion är fortfarande under utveckling",
  重置密码: "Återställ lösenord",
  "请输入为8-20位，必须包含字母、数字和特殊字符":
    "Ange 8-20 tecken, inklusive bokstäver, siffror och specialtecken",
  修改成功: "Ändring lyckades",
  输入验证码: "Ange verifieringskod",
  输入密码: "Ange lösenord",
  详情说明: "Detaljer",
  已售罄: "Slutsåld",
  剩余期限: "Återstående löptid",
  限期: "Löptid",
  闪兑货币选择: "Välj valuta för snabbväxling",
  地区选择: "Välj region",
  "搜索国家/地区": "Sök land/region",
  "身份信息已提交，将在*小时内审核完成":
    "Identitetsinformation skickad. Behandling tar upp till * timmar.",
  "选择国家/地区": "Välj land/region",
  "止盈价格需高于*": "Take-profit-pris måste vara högre än *",
  "止损价格需低于*": "Stop-loss-pris måste vara lägre än *",
  "止盈价格需低于*": "Take-profit-pris måste vara lägre än *",
  "止损价格需高于*": "Stop-loss-pris måste vara högre än *",
  教程详情: "Guide detaljer",
  请输入止损价: "Ange stop-loss-pris",
  活期: "Flexibel",
  赎回后立即到账: "Omedelbar kreditering efter inlösen",
  赎回: "Inlösen",
  赎回理财: "Lös in finansprodukt",
  是否赎回当前的理财订单: "Lös in nuvarande finansproduktorder?",
  维护: "Underhåll",
  "系统正在维护中……": "Systemet är under underhåll...",
  合约: "Terminer",
  闪电兑换: "Snabbväxling",
  流水挖矿: "Volymgruvdrift",
  邀请豪礼: "Inbjudningsbonus",
  计算器: "Kalkylator",
  最新价: "Senaste pris",
  涨跌幅: "Förändring (24h)",
  关注币种添加自选: "Lägg till kryptovaluta i favoriter",
  一键添加自选: "Lägg till i favoriter (ett klick)",
  全标已读: "Markera alla som lästa",
  无消息: "Inga meddelanden",
  "暂时还没有收到任何消息通知哦!": "Du har inte fått några aviseringar än!",
  没有更多数据: "Inga fler data",
  闪兑: "Snabbväxling",
  从: "Från",
  "可用余额：": "Tillgängligt saldo:",
  至: "Till",
  预览兑换结果: "Förhandsgranska växlingsresultat",
  闪兑规则: "Regler för snabbväxling",
  "市场闪兑可能变动，请以实际到账的金额数量为准。":
    "Snabbväxling är föremål för marknadsfluktuationer. Det faktiskt mottagna beloppet är bindande.",
  "对汇兑率由第三方制定，由于兑换成本以及市场波动，您兑换的汇率可能会高于市场的汇率，请仔细确认后进行操作。":
    "Växlingskurser fastställs av tredje part. På grund av kostnader och fluktuationer kan kursen avvika från marknadskursen. Kontrollera noggrant.",
  "平台对每笔汇兑收取大约*%的手续费，用于支付在交易所兑换成本。":
    "Plattformen tar ut cirka *% avgift per växling för att täcka kostnader på börser.",
  确认汇兑: "Bekräfta växling",
  您预估得到: "Beräknat mottagande",
  汇兑: "Växling",
  汇兑比例: "Växlingskurs",
  刷新: "Uppdatera",
  兑换: "Växla",
  没有更多了: "Inga fler data",
  搜索币种: "Sök kryptovaluta",
  可用: "Tillgänglig",
  我知道了: "Jag förstår",
  最新价格: "Senaste pris",
  确认: "Bekräfta",
  最大: "Max",
  "风险率(%)": "Riskprocent (%)",
  当前委托: "Aktuella ordrar",
  合作交易历史记录: "Partner transaktionshistorik",
  重置: "Återställ",
  余额: "Saldo",
  现货账户: "Spotkonto",
  合约账户: "Terminskonto",
  WIN账户: "WIN-konto",
  赏金账户: "Bonus-konto",
  总资产折合: "Totala tillgångar (i USDT)",
  今日收益: "Dagens avkastning",
  充币: "Insättning",
  提币: "Uttag",
  账户权益: "Kontovärde",
  "数量/类别": "Kvantitet/Kategori",
  全部币种: "Alla kryptovalutor",
  全部类型: "Alla typer",
  账单信息: "Fakturainformation",
  理财赎回: "Inlösen av finansprodukt",
  购买理财: "Köp av finansprodukt",
  收入: "Inkomster",
  支出: "Utgifter",
  到: "till",
  资产划转: "Överföring av tillgångar",
  "最少*": "Minimum *",
  "可用资产：": "Tillgängliga tillgångar:",
  确认划转: "Bekräfta överföring",
  "只有将资产划转至对于的账户才可以进行交易，账户间的划转不收取手续费。":
    "Du måste överföra tillgångar till rätt konto för att kunna handla. Överföringar mellan konton är gratis.",
  币种账户选择: "Välj kryptovalutakonto",
  选择账户: "Välj konto",
  划转详情: "Överföringsdetaljer",
  划转明细: "Överföringsspecifikationer",
  收入账单: "Inkomstfaktura",
  支出账单: "Utgiftsfaktura",
  金额: "Belopp",
  总收益: "Total avkastning",
  佣金: "Provision",
  用户名: "Användarnamn",
  "已领取：": "Mottagen:",
  "未领取：": "Ej mottagen:",
  "请选择国家/地区": "Välj land/region",
  请上传身份信息: "Ladda upp identitetsinformation",
  请选择证件类型: "Välj dokumenttyp",
  请填写证件编码: "Ange dokumentnummer",
  请填写名字: "Ange förnamn",
  请填写姓氏: "Ange efternamn",
  投资金额: "Investeringsbelopp",
  天: "dagar",
  请输入手机号: "Ange mobilnummer",
  搜索: "Sök",
  搜索历史: "Sökhistorik",
  热门推荐: "Populära rekommendationer",
  "《Xspace Earn协议》": "Xspace Earn-protokollet",
  我已了解并同意: "Jag förstår och godkänner",
  协议: "Protokoll",
  Xspace官方中文交流群: "Xspace officiella kinesiska gemenskap",
  Xspace官方英文交流群: "Xspace officiella engelska gemenskap",
  预计维护至: "Förväntat underhåll till",
  更多功能: "Fler funktioner",
  下载APP: "Ladda ner app",
  理财: "Finansprodukt",
  推荐: "Rekommenderad",
  Telegram官方中文频道: "Officiell Telegram-kanal (kinesiska)",
  Telegram官方英文频道: "Officiell Telegram-kanal (engelska)",
  官方邮箱: "Officiell e-postadress",
  客服邮箱: "Kundservice e-postadress",
  上述信息最终解释权归官方所有:
    "Ovanstående information är föremål för officiell tolkning av plattformen.",
  IOS版下载: "Ladda ner för iOS",
  Android版下载: "Ladda ner för Android",
  "手续费=买入手续费+资金费率+卖出手续费":
    "Transaktionsavgift = Köpavgift + Finansieringsränta + Säljavgift",
  资金划转: "Överföring av medel",
  止盈: "Take-profit",
  止损: "Stop-loss",
  自动平仓: "Automatisk stängning",
  委托挂单: "Öppen order",
  买: "Köp",
  卖: "Sälj",
  "买入/做多": "Köp/Long",
  "卖出/做空": "Sälj/Short",
  详情: "Detaljer",
  浮动涨跌: "Orealiserad vinst/förlust",
  最小: "Minimum",
  充币数量: "Insättningsmängd",
  请输入充币数量: "Ange insättningsmängd",
  支付截图: "Betalningsbevis",
  提交: "Skicka",
  上传驾驶证: "Ladda upp körkort",
  上传护照: "Ladda upp pass",
  加载中: "Laddar...",
  上传成功: "Uppladdning lyckades",
  充值历史: "Insättningshistorik",
  合约卖出手续费: "Termins säljavgift",
  合约买入手续费: "Termins köpavgift",
  系统加款: "Systemkreditering",
  系统减款: "Systemdebitering",
  合约资金费率: "Termins finansieringsränta",
  佣金分成: "Provisionsdelning",
  U本位合约: "USDT-marginal terminer",
  资产管理: "Tillgångsförvaltning",
  APP下载: "Ladda ner app",
  全球领先的数字理财平台:
    "Världens ledande plattform för digital förmögenhetsförvaltning",
  "即刻交易比特币、以太坊等上百种数字资产":
    "Handla omedelbart med Bitcoin, Ethereum och hundratals andra digitala tillgångar",
  "24H涨跌幅": "24h förändring",
  查看更多行情: "Se fler marknader",
  近24小时成交量: "24h volym",
  "提供数百种币币和合约交易对，以满足多样化的交易需求。 平台在200个国家和地区中有超过2千万用户，是全球领先的数字资产服务平台。":
    "Erbjuder hundratals spot- och terminspar. Över 20 miljoner användare i 200+ länder. En världsledande plattform för digitala tillgångar.",
  用户国家分布: "Användare per land",
  用户数: "Antal användare",
  交易对: "Handelspar",
  服务支持: "Support",
  "随时随地，多平台终端交易":
    "Handla var som helst med plattformsoberoende stöd",
  "多终端完美兼容，随时满足各种场景的交易需求。":
    "Kompatibel med flera enheter för alla handelsbehov.",
  随时查看实时行情: "Se realtidspriser var som helst",
  "轻松买卖BTC，ETH，DOGE和其他数字资产":
    "Köp och sälj enkelt BTC, ETH, DOGE och andra digitala tillgångar",
  获取您关注的加密货币价格变化预警:
    "Få prisvarningar för kryptovalutor du följer",
  "查看比特币现货、期货、期权价格":
    "Se Bitcoin spot-, termins- och optionspriser",
  比较各交易所加密货币价格: "Jämför kryptopriser över olika börser",
  开启您的数字货币之旅: "Starta din resa med digitala tillgångar",
  快捷购买数字货币: "Köp kryptovaluta snabbt",
  "使用多种支付方式交易数字货币，安全快捷":
    "Handla säkert och snabbt med flera betalningsmetoder",
  最优的交易费率: "De bästa transaktionsavgifterna",
  "优惠的交易费率，富有竞争力的VIP权益，享受最优品质的服务":
    "Förmånliga priser, konkurrenskraftiga VIP-förmåner och service av högsta kvalitet.",
  可信赖的安全保障: "Pålitlig säkerhet",
  "我们复杂的安全措施和SAFU基金保护您的数字资产免受所有风险。":
    "Avancerade säkerhetsåtgärder och SAFU-fonden skyddar dina tillgångar mot risker.",
  交易: "Handel",
  币币市场: "Spotmarknad",
  "24H成交量": "24h volym",
  交易所: "Börs",
  "24H最高": "24h högsta",
  "24H最低": "24h lägsta",
  永续合约: "Perpetual terminer",
  日涨跌: "Daglig förändring",
  交易深度: "Orderdjup",
  "资产(合约)": "Tillgångar (Terminer)",
  历史仓位: "Positionshistorik",
  兑换记录: "Växlingshistorik",
  类型: "Typ",
  充值记录: "Insättningshistorik",
  划转记录: "Överföringshistorik",
  类别: "Kategori",
  历史账单: "Fakturahistorik",
  在线充值: "Online insättning",
  安全设置: "Säkerhetsinställningar",
  用于账户登录使用: "Används för kontoinloggning",
  用户提现时安全验证使用: "Används för säkerhetsverifiering vid uttag",
  验证: "Verifiera",
  万: "miljon",
  随时随地开启交易: "Börja handla var som helst",
  "*货币交易所的所有功能尽在你的手中。":
    "Alla funktioner på * kryptobörsen i din hand.",
  "下载*货币交易所APP。": "Ladda ner * kryptobörs-appen.",
  下载自: "Ladda ner från",
  内测版: "Betaversion",
  下载: "Ladda ner",
  扫码下载: "Skanna för att ladda ner",
  设置您的资产密码: "Ange ditt tillgångslösenord",
  法币: "Fiat",
  我要买: "Jag vill köpa",
  我要卖: "Jag vill sälja",
  请输入金额: "Ange belopp",
  汇率: "Växlingskurs",
  获得: "Få",
  支付通道: "Betalningskanal",
  收款通道: "Mottagningskanal",
  "出售过程需要务必确认好您的收款方式为本人。":
    "Se till att mottagningskanalen är i ditt namn när du säljer.",
  当前法币暂不支持交易对可尝试前往提现:
    "Detta fiat-par stöds för närvarande inte. Försök med ett uttag.",
  前往提现: "Gå till uttag",
  该法币暂无通道: "Ingen tillgänglig kanal för denna fiat-valuta",
  "正在出售中，请耐心等待": "Försäljning pågår, vänligen vänta",
  请选择支付通道: "Välj betalningskanal",
  请选择方式: "Välj metod",
  法币历史: "Fiat-historik",
  买币: "Köp krypto",
  卖币: "Sälj krypto",
  失败: "Misslyckades",
  已完成: "Slutförd",
  未付款: "Obetald",
  待审核: "Under behandling",
  打款中: "Utbetalning pågår",
  订单详情: "Orderdetaljer",
  联系客服: "Kontakta kundservice",
  到账金额: "Mottaget belopp",
  通道: "Kanal",
  收款人: "Mottagare",
  收款账户: "Mottagarkonto",
  "订单出售失败，请查下方失败原因":
    "Försäljning av order misslyckades. Se orsaken nedan.",
  失败原因: "Orsak till misslyckande",
  您还未进行付款: "Du har inte betalat än",
  您已成功购买: "Köpet lyckades",
  已取消订单: "Order avbruten",
  "订单正在审核中，请耐心等待": "Ordern behandlas. Vänligen vänta.",
  您已成功出售: "Försäljningen lyckades",
  "订单正在打款中，请耐心等待": "Utbetalning pågår. Vänligen vänta.",
  "支付过程需要您前往其他的平台进行支付订单，请注意信息安全。":
    "För betalning måste du besöka en annan plattform. Var uppmärksam på din informationssäkerhet.",
  当前法币暂不支持交易对可尝试前往充值:
    "Detta fiat-par stöds för närvarande inte. Försök med en insättning.",
  前往充值: "Gå till insättning",
  购买: "Köp",
  订单号: "Ordernummer",
  单价: "Enhetspris",
  到账数量: "Mottagen kvantitet",
  "当前存在未付的订单，是否继续发起新的支付订单？":
    "Det finns en obetald order. Vill du starta en ny betalningsorder?",
  继续支付: "Fortsätt betala",
  重新下单: "Ny beställning",
  是否确定出售: "Är du säker på att du vill sälja?",
  "确定出售后，平台将分配给买家，请耐心等待平台的撮合。":
    "Efter bekräftelse kommer plattformen att tilldela en köpare. Vänta på matchningen.",
  出售: "Sälj",
  收款方式: "Mottagningsmetod",
  订单已生成: "Order genererad",
  取消订单: "Avbryt order",
  请在: "Vänligen inom",
  内完成付款: "slutför betalningen",
  "离开平台，登录您指定的支付，转账到卖家的以下账户，并务必在付款中备注：":
    "Lämna plattformen, logga in på din valda betalningsmetod och överför beloppet till säljarens följande konto. Ange alltid referensen:",
  "若付款时未进行备注，卖家将无法确认收款，造成资产损失无法找回。":
    "Utan referens kan säljaren inte bekräfta betalningen, vilket kan leda till förlust av tillgångar.",
  "未在规定的时间内付款，订单都将被取消。":
    "Om du inte betalar inom den angivna tiden kommer ordern att avbrytas.",
  姓名: "Namn",
  收款姓名: "Mottagarens namn",
  开户支行: "Bankfilial",
  银行卡号: "Bankkortsnummer",
  "付款后，返回本平台": "Efter betalning, återvänd till denna plattform",
  "请务必点击下方“我已完成付款，通知卖家”按钮":
    "Klicka på knappen 'Jag har slutfört betalningen, meddela säljaren'",
  未点击卖家不会放款:
    "Säljaren kommer endast att frigöra krypton efter att du klickat på knappen",
  交易条款: "Transaktionsvillkor",
  "购买资金来源，必须合法安全的资金，方可交易":
    "Medlen för köpet måste vara lagliga och säkra",
  "不允许诈骗、传销、赌博或者其他非法资金交易":
    "Bedrägeri, pyramidspel, spel eller andra olagliga medel är inte tillåtna",
  "交易完成后，出现资金风险，被冻结或者涉嫌欺诈、传销、赌博的资金，我方将不在向买方放U，并给予退款":
    "Om medlen fryses eller är misstänkta efter transaktionen kommer vi inte att frigöra USDT och kommer att ge en återbetalning",
  "已付款，通知卖家": "Betald, meddela säljaren",
  "买方当日累计取消*笔订单，将会取消当日购买功能。确定取消该订单吗？":
    "Om du avbryter totalt * ordrar idag, kommer din köprätt för dagen att återkallas. Avbryt denna order?",
  添加收款方式: "Lägg till mottagningsmetod",
  是否删除此收款方式: "Radera denna mottagningsmetod?",
  删除: "Radera",
  请选择法币: "Välj fiat-valuta",
  机构名称: "Institutionens namn",
  请选择机构: "Välj institution",
  "当您出售数字货币时，您选择的收款方式将向买方展示，请确认填写无误。":
    "Din valda mottagningsmetod kommer att visas för köpare när du säljer krypto. Se till att uppgifterna är korrekta.",
  请选择银行: "Välj bank",
  请输入姓名: "Ange namn",
  账号: "Kontonummer",
  请输入账号: "Ange kontonummer",
  收款码: "Mottagningskod",
  "银行账号/卡号": "Bankkonto/Kortnummer",
  "请输入银行账号/卡号": "Ange bankkonto/kortnummer",
  "开户支行（选填）": "Bankfilial (valfritt)",
  请输入开户支行: "Ange bankfilial",
  "加入*官方频道": "Gå med i den officiella *-kanalen",
  关于: "Om",
  条款: "Villkor",
  成功: "Lyckades",
  等待: "Vänta",
  作废: "Ogiltig",
  确认付款: "Bekräfta betalning",
  "是否已完成付款？若确认付款后，商家将会在*分内进行确认是否收到付款。":
    "Betalning slutförd? Efter bekräftelse kommer säljaren att bekräfta mottagandet inom * minuter.",
  最大金额: "Maximalt belopp",
  最小金额: "Minsta belopp",
  付款: "Betala",
  法币充值: "Fiat-insättning",
  法币提现: "Fiat-uttag",
  待支付: "Väntar på betalning",
  已支付: "Betald",
  商户名: "Säljarens namn",
  当前没有添加支付方式: "Ingen betalningsmetod tillagd",
  添加后再出售: "Lägg till en innan du säljer",
  新人大礼包: "Välkomstpaket",
  注册即可领取: "Motta efter registrering",
  立即领取: "Motta nu",
  不再提示: "Visa inte igen",
  "该奖励需在APP中领取，请下载APP":
    "Denna belöning kan endast mottas i appen. Ladda ner appen.",
  去交易: "Gå till handel",
  期权交易: "Optionshandel",
  交易额: "Handelsbelopp",
  可用额度: "Tillgänglig gräns",
  交易周期: "Handelsperiod",
  看涨: "Bullish (Call)",
  看跌: "Bearish (Put)",
  看空: "Short",
  当前持有: "Nuvarande position",
  胜率: "Vinstprocent",
  "盈利/亏损数": "Antal vinst/förlusttransaktioner",
  累计实现盈亏: "Realiserad total vinst/förlust",
  秒: "sekunder",
  分: "minuter",
  小时: "timmar",
  周: "vecka",
  下单时间: "Ordertid",
  剩余时间: "Återstående tid",
  买入价: "Köppris",
  结算价: "Avräkningspris",
  实现盈利: "Realiserad vinst",
  结算时间: "Avräkningstid",
  期权: "Option",
  新手教程: "Guide för nybörjare",
  我的订单: "Mina ordrar",
  赔率: "Odds",
  全部订单: "Alla ordrar",
  持有订单: "Öppna ordrar",
  历史订单: "Orderhistorik",
  输入交易额度: "Ange handelsbelopp",
  选择交易周期: "Välj handelsperiod",
  去注册: "Registrera dig",
  冻结: "Frys",
  期权支出: "Optionskostnad",
  期权收入: "Optionsintäkt",
  用户提现: "Användaruttag",
  "是否购买？": "Köp denna option?",
  购买成功: "Köp lyckades",
  请签名: "Vänligen signera",
  提交签名: "Skicka signatur",
  清空签名: "Rensa signatur",
  签名审核中: "Signatur under behandling",
  已提交: "Skickad",
  扫一扫下载APP: "Skanna för att ladda ner appen",
  新手领取大礼包: "Välkomstpaket för nya användare",
  注册实名即送彩金: "Registrera och verifiera för att få bonus",
  交易总额: "Total handelsvolym",
  资产不足: "Otillräckliga tillgångar",
  "Win账户的资产不足，可从资金账户划转至此账户":
    "Otillräckliga tillgångar på WIN-kontot. Du kan överföra tillgångar från ditt huvudkonto.",
  Win: "WIN",
  比赛: "Tävling",
  未开始: "Ej startad",
  赛程: "Schema",
  赛果: "Resultat",
  已结束: "Avslutad",
  让球: "Handikapp",
  进球数: "Mål",
  大: "Över",
  小: "Under",
  胜负平: "1X2 (Vinst/Oavgjort/Förlust)",
  和局: "Oavgjort",
  投注: "Insats",
  下注金额: "Insatsbelopp",
  下注: "Placera insats",
  阵容: "Laguppställning",
  分析: "Analys",
  输入下注金额: "Ange insatsbelopp",
  下注成功: "Insats placerad",
  投注记录: "Insatshistorik",
  未结算: "Ej avräknad",
  已结算: "Avräknad",
  流水: "Omsättning",
  输赢: "Vinst/Förlust",
  赛时: "Matchtid",
  下注时间: "Insatstid",
  足彩竞猜: "Fotbollstips",
  查看详情: "Se detaljer",
  输: "Förlust",
  赢: "Vinst",
  主: "Hemma",
  客: "Borta",
  主胜: "Hemmavinst",
  客胜: "Bortavinst",
  平: "Oavgjort",
  已延期: "Uppskjuten",
  账号异常: "Kontoavvikelse",
  全场独赢: "Full tid 1X2",
  全场让球: "Full tid Handikapp",
  全场大小: "Full tid Över/Under",
  总进球: "Totalt antal mål",
  拍摄照片要求: "Fotokrav",
  标准拍摄: "Standardfoto",
  边框缺失: "Saknad kant",
  照片模糊: "Oskarp bild",
  闪光强烈: "För stark blixt",
  上传手持证件照: "Ladda upp foto med dokument i handen",
  上传证件照: "Ladda upp dokumentfoto",
  换一张: "Nytt foto",
  出生日期: "Födelsedatum",
  请选择出生日期: "Välj födelsedatum",
  "输入下方正确的图形验证后，获取邮箱验证码进行注册":
    "Ange verifieringskoden nedan för att få en e-postkod för registrering.",
  "您还剩余*次认证次数，超出次数将无法继续认证":
    "Du har fortfarande * verifieringsförsök kvar. Efter denna gräns kan du inte verifiera dig.",
  上半场: "1:a halvlek",
  下半场: "2:a halvlek",
  独赢: "1X2",
  上半场独赢: "1:a halvlek 1X2",
  下半场独赢: "2:a halvlek 1X2",
  上半场让球: "1:a halvlek Handikapp",
  下半场让球: "2:a halvlek Handikapp",
  上半场大小球: "1:a halvlek Över/Under",
  下半场大小球: "2:a halvlek Över/Under",
  波胆: "Korrekt resultat",
  上半场波胆: "1:a halvlek Korrekt resultat",
  下半场波胆: "2:a halvlek Korrekt resultat",
  单双: "Udda/Jämn",
  单: "Udda",
  双: "Jämn",
  上半场单双: "1:a halvlek Udda/Jämn",
  下半场单双: "2:a halvlek Udda/Jämn",
  上半场总进球: "1:a halvlek Totalt mål",
  下半场总进球: "2:a halvlek Totalt mål",
  中场: "Halvlek",
  "注意：手持证件照请按照此示例图在白纸上书写文字并与证件一起拍摄":
    "Obs: För fotot med dokument i handen, skriv texten på ett vitt papper och fotografera det tillsammans med ditt dokument, som i exemplet.",
  "近期发现大量作弊账户，对一批违规账户进行了惩罚。如果有误判为违规账户，请联系在线客服。":
    "Nyligen har många bedrägliga konton straffats. Kontakta kundservice om du anser att ditt konto har straffats orättvist.",
  最小下注金额: "Minsta insats",
  参与活动最小下注金额: "Minsta insats för att delta i aktiviteten",
  记住密码: "Kom ihåg lösenord",
  比分: "Resultat",
  "您还未登录，请先登录": "Du är inte inloggad. Logga in först.",
  立即登录: "Logga in nu",
  下注限额: "Insatsgräns",
  可赢金额: "Belopp som kan vinnas",
  闪兑详情: "Detaljer för snabbväxling",
  大小球: "Över/Under",
  "由于汇率原因，下注金额和实际下注金额会有误差，请以订单为准。":
    "På grund av valutakursfluktuationer kan det slutliga insatsbeloppet avvika. Ordern är bindande.",
  开赛时间: "Starttid",
  足球收入: "Fotbollsintäkter",
  足球支出: "Fotbollsutgifter",
  活动详情: "Aktivitetsdetaljer",
  为世界杯喝彩: "Stöd världsmästerskapet",
  我的竞猜: "Mina tips",
  "竞猜比赛、有机会瓜分*USDT": "Tipsa om matcher och vinn en del av * USDT",
  "瓜分*USDT": "Dela * USDT",
  距离活动结束还有: "Aktivitet slutar om:",
  我的门票: "Mina biljetter",
  竞猜结束时间: "Slut på tips",
  猜比分: "Tipsa resultat",
  "福利派送中，完成任务即可获取门票":
    "Bonusar delas ut. Slutför uppgifter för att tjäna biljetter.",
  "完成如下任务，可获对应数量门票的参与竞赛":
    "Slutför följande uppgifter för att få motsvarande antal biljetter för att delta i tävlingen.",
  时: "timme",
  活动: "Aktivitet",
  竞猜记录: "Tipshistorik",
  结果: "Resultat",
  任务: "Uppgift",
  去邀请: "Bjud in",
  "每场比赛的比分竞猜，参与竞猜可瓜分$*美金的奖励。":
    "Tipsa om resultatet för varje match och vinn en del av $*.",
  "参与竞猜需要门票，门票可按照平台的任务进行获得。":
    "En biljett krävs för att tipsa. Biljetter kan tjänas genom att slutföra plattformsuppgifter.",
  "竞猜成功后，把竞猜结果的截图发送给客服，客服会把奖金划入您的资金账户，你可以立即提取。":
    "Efter ett lyckat tips, skicka en skärmdump till kundservice. De kommer att kreditera bonusen till ditt konto, som du omedelbart kan ta ut.",
  "禁止任何作弊行为、如果发现作弊行为，奖励无效。":
    "Fusk är förbjudet. Om det upptäcks kommer belöningen att ogiltigförklaras.",
  "完成任务后，点击咨询客服获得门票。":
    "Efter att ha slutfört uppgifterna, klicka på 'Kontakta kundservice' för att få biljetter.",
  继续猜: "Fortsätt tipsa",
  总单数: "Totalt antal spel",
  赛事筛选: "Filtrera efter evenemang",
  球队筛选: "Filtrera efter lag",
  总金额: "Totalt belopp",
  总流水: "Total omsättning",
  派奖金额: "Utbetalt bonusbelopp",
  下注单数: "Antal spel",
  利润: "Vinst",
  更多福利: "Fler bonusar",
  我的奖金: "Min bonus",
  未认证: "Ej verifierad",
  总量: "Totalt",
  或: "eller",
  模拟交易: "Demohandel",
  体验账户不可操作: "Inte tillgängligt på demokonto",
  世界杯比分竞猜: "VM-resultattips",
  "领*USDT起": "Motta från * USDT",
  消息: "Meddelanden",
  滚球: "Live-spel",
  是: "Ja",
  不是: "Nej",
  当前余额: "Nuvarande saldo",
  KOL招募: "KOL-rekrytering",
  本月净输赢: "Netto vinst/förlust denna månad",
  本月佣金: "Provision denna månad",
  佣金比例: "Provisionsprocent",
  活跃人数: "Aktiva användare",
  新增下级: "Nya nedlinjer",
  登录人数: "Inloggade användare",
  首存人数: "Användare med första insättning",
  数据分析: "Dataanalys",
  人数: "Antal personer",
  新注册存款金额: "Insättningsbelopp för nya registreringar",
  老用户存款金额: "Insättningsbelopp för befintliga användare",
  首存金额: "Första insättningsbelopp",
  快捷入口: "Snabbåtkomst",
  成员管理: "Medlemshantering",
  财务报表: "Finansiella rapporter",
  分红报表: "Utbytrapport",
  订单记录: "Orderhistorik",
  VIP专享: "VIP-exklusivt",
  推广工具: "Marknadsföringsverktyg",
  计算规则: "Beräkningsregler",
  账变明细: "Transaktionsdetaljer",
  成员: "Medlemmar",
  下级概览: "Översikt över nedlinjer",
  下级成员总计: "Totalt nedlinjer",
  本月新增: "Nya denna månad",
  本月活跃会员: "Aktiva medlemmar denna månad",
  今日活跃会员: "Aktiva medlemmar idag",
  本月有效活跃: "Effektivt aktiva denna månad",
  活跃成员占比: "Andel aktiva medlemmar",
  本月活跃: "Aktiva denna månad",
  今日活跃: "Aktiva idag",
  下级成员: "Nedlinjer",
  会员账号: "Medlemskonto",
  统计时间: "Statistiktid",
  筛选: "Filtrera",
  存款: "Insättning",
  取款: "Uttag",
  总输赢: "Totalt vinst/förlust",
  是否有效用户: "Aktiv användare?",
  最近登录时间: "Senaste inloggning",
  否: "Nej",
  开始时间: "Starttid",
  结束时间: "Sluttid",
  提取: "Ta ut",
  总盈亏: "Totalt resultat",
  净盈亏: "Nettoresultat",
  分红: "Utdelning",
  概览: "Översikt",
  月度详细数据: "Månatliga detaljdata",
  未发放: "Ej utbetald",
  活跃用户: "Aktiva användare",
  有效新增会员: "Effektiva nya medlemmar",
  冲正后净输赢: "Netto vinst/förlust efter korrigering",
  上月结余: "Saldo föregående månad",
  净输赢: "Netto vinst/förlust",
  "系统每日新加坡时间1:00更新一次报表":
    "Rapporter uppdateras dagligen kl. 01:00 Singapore-tid.",
  "报表中数据、总输赢、净输赢中正数表示代理方盈利、负数表示代理方亏损":
    "I rapporter betyder positiva siffror vinst för partnern, negativa siffror betyder förlust för partnern.",
  "佣金数据每天进行更新，仅供参考，并不做实际佣金派发标准":
    "Provisionsdata uppdateras dagligen, är vägledande och utgör inte en slutgiltig utbetalningsgrund.",
  选择时间: "Välj tid",
  足球: "Fotboll",
  投注金额: "Insatsbelopp",
  有效订单: "Giltiga ordrar",
  下级账户: "Nedlinjekonto",
  待成交: "Väntar",
  下单金额: "Orderbelopp",
  订单内容: "Orderinnehåll",
  秒数: "Sekunder",
  联赛: "Liga",
  队伍: "Lag",
  比赛时间: "Matchstart",
  玩法: "Speltyp",
  等级规则表: "Nivåregeltabell",
  等级: "Nivå",
  活跃会员: "Aktiva medlemmar",
  最新活跃: "Senaste aktivitet",
  额外佣金: "Extra provision",
  "每月按照对应等级的增长标准与奖励制度执行，只可享受一个等级奖励。":
    "Månadsvis baserat på tillväxtstandarder. Du kan bara dra nytta av en nivå.",
  渠道生成: "Generera kanal",
  创建: "Skapa",
  渠道名称: "Kanalnamn",
  注册人数: "Antal registreringar",
  浏览人数: "Antal visningar",
  构建状态: "Byggstatus",
  禁用: "Inaktivera",
  启用: "Aktivera",
  查看: "Se",
  创建渠道: "Skapa kanal",
  创建成功: "Skapelse lyckades",
  操作成功: "Åtgärd lyckades",
  渠道详情: "Kanaldetaljer",
  邀请码: "Inbjudningskod",
  访问人数: "Antal besökare",
  渠道地址: "Kanaladress",
  我的福利: "Mina bonusar",
  充值福利: "Insättningsbonus",
  当前流水: "Nuvarande omsättning",
  如何参与: "Hur man deltar",
  币种充值: "Kryptovalutainsättning",
  充值福利中领取福利: "Motta bonus vid insättningsbonus",
  "规则：充值福利自愿领取，有效期为充值后的24小时内，过期无效，领取后将暂时锁定提现功能，当流水达到后即可解锁提现。":
    "Regel: Insättningsbonusen är frivillig, giltig i 24 timmar efter insättning. Efter mottagning kommer uttag att tillfälligt blockeras tills omsättningskravet är uppnått.",
  失效日期: "Utgångsdatum",
  "暂无福利领取，充值后领取":
    "Ingen bonus tillgänglig. Motta efter insättning.",
  参与: "Delta",
  充值赠送: "Insättningsbonus",
  "领取*%的赠送": "Motta *% bonus",
  去领取: "Motta",
  VIP奖励: "VIP-belöning",
  "当前可领取*USDT，是否确认领取":
    "* USDT tillgängligt för mottagning. Bekräfta?",
  "领取后将临时锁定提现功能，当您的流水到达*USDT后即可解除锁定":
    "Efter mottagning kommer uttag att tillfälligt blockeras tills en omsättning på * USDT har uppnåtts.",
  充值送大礼: "Insättningsgåva",
  "存入越多，送越多！": "Ju mer du sätter in, desto större gåva!",
  无效: "Ogiltig",
  有效: "Giltig",
  总存金额: "Totalt insatt belopp",
  提示: "Observera",
  "总输赢，净输赢中正数表示平台盈利，负数表示亏损，每天数据只做参考，并不做实际佣金派发标准。":
    "Positiva siffror i total och netto vinst/förlust betyder plattformsvinst. Dagliga data är vägledande.",
  "净盈亏：总盈亏-用户返水":
    "Nettoresultat: Totalt resultat - Cashback till användare",
  盈利方: "Vinstpart",
  代理: "Agent",
  客户: "Kund",
  平局: "Oavgjort",
  平台: "Plattform",
  "已提交审核，请耐心等待": "Skickad för verifiering. Vänligen vänta.",
  充值日期: "Insättningsdatum",
  平台本月总输赢: "Plattformens totala vinst/förlust denna månad",
  KOL招募合作: "KOL-rekryteringssamarbete",
  "平台现在开放【KOL招募活动】，只要您有社群媒体号，就可以和平台享受分红一次性推广客户，就可以享受终生收益。":
    "Plattformen öppnar KOL-rekrytering. Med ett socialt mediekonto kan du njuta av utdelning och livslång inkomst genom engångskundvärvning.",
  级别: "Nivå",
  平台利润返佣: "Plattforms vinstprovision",
  佣金案例: "Provisionsexempel",
  交易项目: "Handelsprodukter",
  "期权交易、合约交易、足球游戏": "Optionshandel, terminshandel, fotbollsspel",
  报名方式: "Anmälningsmetod",
  点击KOL招募报名: "Klicka för att anmäla dig till KOL-rekrytering",
  "欢迎加入我们的团队，平台全面扶持您建立属于自己的用户体系，最高可得*的佣金，我们期待您加入。":
    "Välkommen till vårt team. Vi stödjer dig i att bygga ditt eget användarsystem. Tjäna upp till *% provision. Vi ser fram emot ditt deltagande.",
  输入联系方式: "Ange kontaktinformation",
  最低活跃人数: "Minsta antal aktiva användare",
  "如：本月活跃人数≥*并且本月平台总输赢≥*USDT，您属于等级*，即可得到*%的佣金。":
    "T.ex.: Om aktiva användare denna månad ≥ * och plattformens totala vinst/förlust ≥ * USDT, tillhör du nivå * och får *% provision.",
  比分竞猜: "Resultattips",
  豪礼相赠: "Stor gåva",
  足球活动: "Fotbollsaktivitet",
  圣诞节活动: "Julaktivitet",
  "您参加了活动，临时锁定提现功能，还需*USDT流水就可以解除锁定。":
    "Du har deltagit i en aktivitet. Uttag är tillfälligt blockerat. Du behöver fortfarande * USDT i omsättning för att låsa upp.",
  剩余流水: "Återstående omsättning",
  助力足球: "Stöd fotboll",
  佣金累计: "Total provision",
  有效投注: "Giltiga spel",
  今日: "Idag",
  今日返水: "Cashback idag",
  VIP返水: "VIP-cashback",
  返水记录: "Cashbackhistorik",
  成员信息: "Medlemsinformation",
  基本信息: "Grundinformation",
  钱包余额: "Plånbokssaldo",
  投注信息: "Spelinformation",
  返水: "Cashback",
  总下注: "Total insats",
  今日输赢: "Vinst/förlust idag",
  下注动态: "Spelaktivitet",
  返水奖励: "Cashback-belöning",
  分红金额: "Utdelningsbelopp",
  返水支出: "Cashback-kostnad",
  总返水: "Total cashback",
  流水总额: "Total omsättning",
  返水总额: "Total cashback",
  返水详情: "Cashback-detaljer",
  日流水: "Daglig omsättning",
  "平台根据你下级每日流水进行额外返水奖励,奖励每日新加坡时间00：00进行派发至赏金账户":
    "Plattformen ger extra cashback baserat på daglig omsättning av dina nedlinjer. Utbetalning dagligen kl. 00:00 Singapore-tid till bonus-konto.",
  "申请成功，等待审核": "Ansökan lyckades, väntar på verifiering",
  "我出本金，盈利共分享": "Jag ger kapital, vinsten delas",
  最高分红: "Maximal utdelning",
  投资大师比赛: "Master Investor-tävling",
  "我出本金，你盈利": "Jag ger kapital, du tjänar",
  共分享: "Dela tillsammans",
  最高分红可得: "Maximal möjlig utdelning",
  "新用户专属福利来袭，免费赠送$*，领取后即可投资平台任何项目，盈利后立即可提取。":
    "Exklusiv välkomstbonus: $* gratis. Efter mottagning kan du investera i vilket projekt som helst. Vinst kan omedelbart tas ut.",
  报名领取: "Anmäl dig och motta",
  审核驳回: "Verifiering avvisad",
  驳回原因: "Orsak till avvisning",
  活动运行周期: "Aktivitetsperiod",
  "申请成功后起至*天内完成超额收益。":
    "Uppnå överavkastning inom * dagar efter godkännande.",
  分红比: "Utdelningsandel",
  "*日获得盈利后，可获得*%的收益额。":
    "Efter att ha uppnått vinst på dag *, får du *% av avkastningsbeloppet.",
  参与条件: "Deltagandevillkor",
  "俄罗斯、土耳其地区的用户，且未参与。":
    "Användare från Ryssland eller Turkiet som inte har deltagit än.",
  计算项目: "Beräknade produkter",
  "合约、体育、期权": "Terminer, Sport, Optioner",
  我的投资: "Mina investeringar",
  参与天数: "Deltagandedagar",
  累计下注: "Total insats",
  累计盈亏: "Total vinst/förlust",
  预计可分红: "Förväntad utdelning",
  常见问题: "Vanliga frågor (FAQ)",
  什么是平台出资: "Vad är plattformsfinansiering?",
  "平台根据部分国家的用户，免费提供资金让用户去投项目。":
    "Plattformen ger gratis medel till användare från specifika länder för att investera i projekt.",
  怎么获取平台出资的福利: "Hur får jag plattformsfinansieringsbonusen?",
  "您是指定国家的用户即可，点击上方报名按钮，当平台审核完成后将会把*USDT转入当前账户下的赏金账户，您可划转至其他账户下进行投资。":
    "Om du är från ett av de angivna länderna, klicka på anmälningsknappen. Efter godkännande kommer * USDT att överföras till ditt bonus-konto, som du kan överföra för att investera.",
  什么是分红: "Vad är utdelning?",
  "分红指在规定时间内，收益额到达100%后，可分得超额收益的50%。例如：领取100USDT资金，收益额度是120%。":
    "Utdelning: Om avkastningen når 100% inom den angivna tiden, får du 50% av överavkastningen. T.ex.: Motta 100 USDT, uppnå 120% avkastning, då är 20% överavkastning.",
  "如何取得分红？": "Hur får jag utdelning?",
  "活动周期每*天1次，活动结束后进行核算，满足活动要求后分红派发至赏金账户。若你未达到活动要求，系统将自动清除你的收益额和平台的出资。":
    "Aktivitetscykeln är varje * dag. Efter slutförande görs avräkning. Om du uppfyller kraven skickas utdelningen till bonus-kontot. Om inte, kommer din avkastning och plattformsfinansieringen att tas bort.",
  "参与的账号需进行KYC认证，每个账户仅限一份福利。":
    "Deltagande konton måste vara KYC-verifierade. Endast en bonus per konto.",
  "参与账号的KYC需要指定的国家方可参与，其他地区无权限参与，请核对活动国家与您的国家是否一致。":
    "KYC för deltagande är endast giltig för angivna länder. Kontrollera om ditt land matchar aktivitetslandet.",
  "参与活动成功后，账户将临时锁定您的提现功能，当完成活动后即可解除您的提现功能。":
    "Efter framgångsrikt deltagande kommer uttag att tillfälligt blockeras tills aktiviteten är slutförd.",
  "请遵守平台活动规则，若发现作弊、利用系统漏洞进行获利，平台将会长期冻结您的账户下所有资金。":
    "Följ aktivitetsreglerna. Vid fusk eller missbruk av systemfel kommer alla medel på ditt konto att frysas permanent.",
  平台出资: "Plattformsfinansiering",
  平台出资收回: "Plattformsfinansiering återkallad",
  投资大师奖励: "Master Investor-belöning",
  请下载APP添加收款方式: "Ladda ner appen för att lägga till mottagningsmetod",
  请下载APP进行身份验证: "Ladda ner appen för att utföra identitetsverifiering",
  请下载APP参与: "Ladda ner appen för att delta",
  技术指标: "Tekniska indikatorer",
  主图: "Huvuddiagram",
  副图: "Sekundärt diagram",
  新注册人数: "Nya registreringar",
  老用户存款人数: "Befintliga användare som sätter in",
  存款人数: "Antal insättningar",
  取款人数: "Antal uttag",
  投注人数: "Antal spel",
  "除印度尼西亚、印度、孟加拉国，且未参与过的用户。":
    "Exklusive användare från Indonesien, Indien, Bangladesh som inte har deltagit än.",
  市场动态: "Marknadsdynamik",
  外汇合约: "Forex-terminer",
  盈亏比: "Vinst/förlust-kvot",
  委托价: "Orderpris",
  可用余额: "Tillgängligt saldo",
  持仓额: "Positionsvärde",
  强平价: "Likvideringspris",
  修改: "Ändra",
  修改价位: "Ändra pris",
  外汇: "Forex",
  外汇账户: "Forexkonto",
  我的交易: "Mina transaktioner",
  未设置: "Ej inställd",
  超出最大可设数值: "Överskrider maximalt inställbart värde",
  超出最小可设数值: "Under minimalt inställbart värde",
  止盈超出最小可设数值: "Take-profit under minimalt inställbart värde",
  止损超出最大可设数值: "Stop-loss överskrider maximalt inställbart värde",
  止盈超出最大可设数值: "Take-profit överskrider maximalt inställbart värde",
  止损超出最小可设数值: "Stop-loss under minimalt inställbart värde",
  挖矿: "Gruvdrift",
  交易账户: "Handelskonto",
  买涨: "Köp (Long)",
  买跌: "Sälj (Short)",
  请输入正确的银行卡信息: "Ange korrekt bankkortsinformation",
  联系在线客服: "Kontakta live kundservice",
  法币交易请联系在线客服: "Kontakta kundservice för fiat-handel",
  提交订单: "Skicka order",
  "支付过程如有疑问,请联系在线客服":
    "Kontakta kundservice om du har frågor om betalningsprocessen",
  彩金赠送: "Bonustilldelning",
  在线客服: "Livechatt",
  最少投资: "Minsta investering",
  "提交时间:": "Inskickningstid:",
  提现拒绝: "Uttag avvisat",
  认证拒绝: "Verifiering avvisad",
  认证通过: "Verifiering godkänd",
  请输入正确的交易额度: "Ange ett giltigt handelsbelopp",
  最大下注金额: "Maximal insats",
  手机号: "Mobilnummer",
  邮箱注册: "Registrera med e-post",
  手机号注册: "Registrera med mobilnummer",
  查询: "Sök",
  手机号登录: "Logga in med mobilnummer",
  邮箱登录: "Logga in med e-post",
  请输入数量: "Ange kvantitet",
  可用数量: "Tillgänglig kvantitet",
  钱包登录: "Logga in med plånbok",
  请输入正确的邀请码: "Ange en giltig inbjudningskod",
  "请输入邀请码(必填)": "Ange inbjudningskod (obligatorisk)",
  输入正确的金额: "Ange ett giltigt belopp",
  法币充值: "Fiat-insättning",
  卢比充值: "Indisk rupi-insättning",
  请输入法币: "Ange fiat-belopp",
  请输入IFSC: "Ange IFSC-kod",
  "银行编码(选填)": "Bankkod (valfritt)",
  请输入银行编码: "Ange bankkod",
  请输入大于8位数的密码: "Ange ett lösenord med mer än 8 tecken",
  添加成功: "Tillagd",
  "60秒": "60 sekunder",
  "180秒": "180 sekunder",
  "300秒": "300 sekunder",
  "2次密码不一致": "Lösenorden matchar inte",
  输入提币数量: "Ange uttagsmängd",
  图片格式不正确: "Ogiltigt bildformat",
  图片大于20M: "Bilden är större än 20 MB",
  请设置委托价格: "Ange ett orderpris",
  输入资金密码: "Ange tillgångslösenord",
  验证码错误: "Fel verifieringskod",
  充值拒绝: "Insättning avvisad",
  请输入SSN: "Ange SSN",
  结算完成: "Avräkning slutförd",
  继续下单: "Fortsätt beställa",
  限价: "Limitorder",
  买入价格: "Köppris",
  买入量: "Köpskvantitet",
  卖出价格: "Säljpris",
  卖出量: "Säljkvantitet",
  买入: "Köp",
  卖出: "Sälj",
  订单创建成功: "Order skapad",
  币币买入支出: "Kostnad för spotköp",
  币币买入支出退还: "Återbetalning av kostnad för spotköp",
  币币买入获得: "Mottagning från spotköp",
  币币卖出支出: "Kostnad för spotsälj",
  币币卖出支出退还: "Återbetalning av kostnad för spotsälj",
  币币卖出获得: "Mottagning från spotsälj",
  币币交易手续费: "Spot transaktionsavgift",
  请输入限价: "Ange limitpris",
  成交: "Verkställd",
  等待成交: "Väntar på verkställande",
  交易完成: "Transaktion slutförd",
  被取消: "Avbruten",
  交易时间: "Transaktionstid",
  法币交易: "Fiat-handel",
  法币出售: "Fiat-försäljning",

  两次密码不一致: "Lösenorden matchar inte",
  再次输入账户密码: "Ange kontolösenordet igen",

  美国: "USA",
  韩国: "Sydkorea",
  阿尔巴尼亚: "Albanien",
  津巴布韦: "Zimbabwe",
  赞比亚: "Zambia",
  也门: "Jemen",
  美属维尔京群岛: "Amerikanska Jungfruöarna",
  英属处女群岛: "Brittiska Jungfruöarna",
  越南: "Vietnam",
  委内瑞拉: "Venezuela",
  瓦努阿图: "Vanuatu",
  乌兹别克斯坦: "Uzbekistan",
  乌拉圭: "Uruguay",
  英国: "Storbritannien",
  阿拉伯联合酋长国: "Förenade Arabemiraten",
  乌克兰: "Ukraina",
  乌干达: "Uganda",
  特克斯和凯科斯群岛: "Turks- och Caicosöarna",
  土库曼斯坦: "Turkmenistan",
  土耳其: "Turkiet",
  突尼斯: "Tunisien",
  特立尼达和多巴哥: "Trinidad och Tobago",
  汤加: "Tonga",
  多哥: "Togo",
  东帝汶: "Östtimor",
  泰国: "Thailand",
  坦桑尼亚: "Tanzania",
  塔吉克斯坦: "Tadzjikistan",
  中国台湾: "Taiwan",
  叙利亚: "Syrien",
  瑞士: "Schweiz",
  瑞典: "Sverige",
  斯威士兰: "Eswatini",
  苏里南: "Surinam",
  苏丹: "Sudan",
  斯里兰卡: "Sri Lanka",
  西班牙: "Spanien",
  南非: "Sydafrika",
  索马里: "Somalia",
  所罗门群岛: "Salomonöarna",
  斯洛文尼亚: "Slovenien",
  斯洛伐克: "Slovakien",
  "圣马丁岛（荷兰部分）": "Sint Maarten (nederländska delen)",
  新加坡: "Singapore",
  塞拉利昂: "Sierra Leone",
  塞舌尔: "Seychellerna",
  塞尔维亚: "Serbien",
  塞内加尔: "Senegal",
  沙特阿拉伯: "Saudiarabien",
  圣多美和普林西比: "São Tomé och Príncipe",
  圣马力诺: "San Marino",
  萨摩亚: "Samoa",
  圣克里斯托弗和尼维斯: "Saint Kitts och Nevis",
  圣文森特和格林纳丁斯: "Saint Vincent och Grenadinerna",
  圣彼埃尔和密克隆岛: "Saint-Pierre och Miquelon",
  圣露西亚: "Saint Lucia",
  圣基茨和尼维斯: "Saint Kitts och Nevis",
  卢旺达: "Rwanda",
  俄罗斯: "Ryssland",
  罗马尼亚: "Rumänien",
  留尼汪: "Réunion",
  刚果共和国: "Republiken Kongo",
  卡塔尔: "Qatar",
  波多黎各: "Puerto Rico",
  葡萄牙: "Portugal",
  波兰: "Polen",
  菲律宾: "Filippinerna",
  秘鲁: "Peru",
  巴拉圭: "Paraguay",
  巴布亚新几内亚: "Papua Nya Guinea",
  巴拿马: "Panama",
  巴勒斯坦: "Palestina",
  帕劳: "Palau",
  巴基斯坦: "Pakistan",
  阿曼: "Oman",
  挪威: "Norge",
  尼日利亚: "Nigeria",
  尼日尔: "Niger",
  尼加拉瓜: "Nicaragua",
  新西兰: "Nya Zeeland",
  新喀里多尼亚: "Nya Kaledonien",
  荷属安德列斯群岛: "Nederländska Antillerna",
  荷兰: "Nederländerna",
  尼泊尔: "Nepal",
  纳米比亚: "Namibia",
  缅甸: "Myanmar",
  莫桑比克: "Moçambique",
  摩洛哥: "Marocko",
  蒙特塞拉特岛: "Montserrat",
  黑山: "Montenegro",
  蒙古: "Mongoliet",
  摩纳哥: "Monaco",
  摩尔多瓦: "Moldavien",
  墨西哥: "Mexiko",
  马约特: "Mayotte",
  毛里求斯: "Mauritius",
  毛里塔尼亚: "Mauretanien",
  马里亚纳群岛: "Marianerna",
  马提尼克: "Martinique",
  马耳他: "Malta",
  马里: "Mali",
  马尔代夫: "Maldiverna",
  马来西亚: "Malaysia",
  马拉维: "Malawi",
  马达加斯加: "Madagaskar",
  马其顿: "Nordmakedonien",
  中国澳门: "Macao",
  卢森堡: "Luxemburg",
  立陶宛: "Litauen",
  列支敦士登: "Liechtenstein",
  利比亚: "Libyen",
  利比里亚: "Liberia",
  莱索托: "Lesotho",
  黎巴嫩: "Libanon",
  拉脱维亚: "Lettland",
  老挝: "Laos",
  吉尔吉斯斯坦: "Kirgizistan",
  科威特: "Kuwait",
  基里巴斯: "Kiribati",
  肯尼亚: "Kenya",
  哈萨克斯坦: "Kazakstan",
  约旦: "Jordanien",
  日本: "Japan",
  牙买加: "Jamaica",
  象牙海岸: "Elfenbenskusten",
  意大利: "Italien",
  以色列: "Israel",
  爱尔兰: "Irland",
  伊拉克: "Irak",
  伊朗: "Iran",
  印度尼西亚: "Indonesien",
  印度: "Indien",
  冰岛: "Island",
  匈牙利: "Ungern",
  中国香港: "Hongkong",
  洪都拉斯: "Honduras",
  海地: "Haiti",
  圭亚那: "Guyana",
  几内亚比绍共和国: "Guinea-Bissau",
  几内亚: "Guinea",
  危地马拉: "Guatemala",
  关岛: "Guam",
  瓜德罗普岛: "Guadeloupe",
  格林纳达: "Grenada",
  格陵兰岛: "Grönland",
  希腊: "Grekland",
  直布罗陀: "Gibraltar",
  加纳: "Ghana",
  德国: "Tyskland",
  格鲁吉亚: "Georgien",
  冈比亚: "Gambia",
  加蓬: "Gabon",
  法属波利尼西亚: "Franska Polynesien",
  法属圭亚那: "Franska Guyana",
  法国: "Frankrike",
  芬兰: "Finland",
  斐济: "Fiji",
  法罗群岛: "Färöarna",
  埃塞俄比亚: "Etiopien",
  爱沙尼亚: "Estland",
  厄立特里亚: "Eritrea",
  赤道几内亚: "Ekvatorialguinea",
  萨尔瓦多: "El Salvador",
  埃及: "Egypten",
  厄瓜多尔: "Ecuador",
  多米尼加共和国: "Dominikanska republiken",
  多米尼加: "Dominica",
  吉布提: "Djibouti",
  丹麦: "Danmark",
  捷克: "Tjeckien",
  塞浦路斯: "Cypern",
  库拉索: "Curaçao",
  古巴: "Kuba",
  克罗地亚: "Kroatien",
  哥斯达黎加: "Costa Rica",
  科特迪瓦: "Elfenbenskusten",
  库克群岛: "Cooköarna",
  科摩罗: "Komorerna",
  哥伦比亚: "Colombia",
  智利: "Chile",
  乍得: "Tchad",
  中非共和国: "Centralafrikanska republiken",
  佛得角: "Kap Verde",
  开曼群岛: "Caymanöarna",
  开普: "Cape",
  加拿大: "Kanada",
  喀麦隆: "Kamerun",
  柬埔寨: "Kambodja",
  布隆迪: "Burundi",
  布基纳法索: "Burkina Faso",
  保加利亚: "Bulgarien",
  文莱: "Brunei",
  巴西: "Brasilien",
  博茨瓦纳: "Botswana",
  波斯尼亚和黑塞哥维那: "Bosnien och Hercegovina",
  玻利维亚: "Bolivia",
  不丹: "Bhutan",
  百慕大群岛: "Bermuda",
  贝宁: "Benin",
  伯利兹: "Belize",
  比利时: "Belgien",
  白俄罗斯: "Vitryssland",
  巴巴多斯: "Barbados",
  孟加拉国: "Bangladesh",
  巴林: "Bahrain",
  巴哈马: "Bahamas",
  阿塞拜疆: "Azerbajdzjan",
  奥地利: "Österrike",
  澳大利亚: "Australien",
  阿鲁巴: "Aruba",
  亚美尼亚: "Armenien",
  阿根廷: "Argentina",
  安提瓜和巴布达: "Antigua och Barbuda",
  安圭拉: "Anguilla",
  安哥拉: "Angola",
  安道尔: "Andorra",
  美属萨摩亚: "Amerikanska Samoa",
  阿尔及利亚: "Algeriet",
  中国: "Kina",
  余额不足: "Otillräckligt saldo",
  最低购买: "Minsta köp",
  最高购买: "Högsta köp",
  下单成功: "Order lagd",
  平仓成功: "Position stängd",
  请输入正确的平仓数量: "Ange en giltig stängningskvantitet",
  加仓成功: "Position ökad",
  请输入正确的加仓金额: "Ange ett giltigt belopp för att öka positionen",
  收藏成功: "Tillagd i favoriter",
  取消收藏成功: "Borttagen från favoriter",
  加密币永续: "Kryptovaluta perpetual",
  外汇永续: "Forex perpetual",
  期权账户: "Optionskonto",
  快捷卖币: "Snabbförsäljning av krypto",

  托管资金: "Förvaltade medel",
  托管中: "Under förvaltning",
  预计日收益: "Beräknad daglig avkastning",
  累计收益: "Total avkastning",
  周期: "Löptid",
  日收益: "Daglig avkastning",
  限额: "Gräns",
  立即托管: "Starta förvaltning nu",
  "已鎖定 請聯繫客服": "Låst. Kontakta kundservice.",
  产品列表: "Produktlista",
  规则: "Regler",
  创建订单: "Skapa order",
  产品名称: "Produktnamn",
  托管周期: "Förvaltningsperiod",
  等级限制: "Nivåbegränsning",
  托管金额: "Förvaltat belopp",
  限额: "Gräns",
  余额: "Saldo",
  购买日: "Köpsdatum",
  起息日: "Räntestartdatum",
  派息时间: "Ränteutbetalningstid",
  每天: "Dagligen",
  计息结束日: "Ränteslutdatum",
  每日收益: "Daglig avkastning",
  预计收益: "Beräknad avkastning",
  "收益将自动发送至您的余额账户;":
    "Avkastning skickas automatiskt till ditt saldo;",
  "您的资金没有任何风险;": "Dina medel är utan risk;",
  "365*24小时不断地工作;": "Arbetar 24/7, 365 dagar om året;",
  托管中: "Under förvaltning",
  结束: "Avslutad",
  今日收益: "Dagens avkastning",
  剩余周期: "Återstående löptid",
  进行中: "Aktiv",
  已发放: "Utbetald",
  信誉分: "Anseendepoäng",

  复制成功: "Kopierades framgångsrikt",
  VIP权益: "VIP-förmåner",
  旧密码: "Gammalt lösenord",
  请输入旧密码: "Ange gammalt lösenord",
  "忘记旧密码请联系客服重置。":
    "Om du har glömt ditt gamla lösenord, vänligen kontakta kundtjänst för att återställa det.",
  去升级: "Uppgradera",
  描述: "Beskrivning",
  实际存款金额: "Faktiskt insättningsbelopp",
  升级礼金: "Uppgraderingsbonus",
  隔夜利息: "Övernattningsränta (swap)",
  自动结算: "Automatisk avräkning",
  等级规则: "Nivåregler",
  "WEB3.0币持有数据收益": "WEB3.0-myntinnehav dataavkastning",
  总生产: "Total produktion",
  有效节点: "Aktiva noder",
  参与人: "Deltagare",
  用户收益: "Användaravkastning",
  "流动性WEB3.0输出": "Likviditet WEB3.0-output",
  总资产: "Totala tillgångar",

  ETHAI持有数据收益: "ETHAI innehavsdataavkastning",
  AI量化流动性: "AI kvantitativ likviditet",
  现货买入手续费: "Spot köpavgift",
  现货支出: "Spot utgift",
  现货资金费率: "Spot finansieringsränta",
  现货卖出手续费: "Spot säljavgift",
  现货收入: "Spot inkomst",
  外汇合约支出: "Valutaterminskontrakt utgift",
  外汇合约买入手续费: "Valutaterminskontrakt köpavgift",
  外汇合约资金费率: "Valutaterminskontrakt finansieringsränta",
  外汇合约卖出手续费: "Valutaterminskontrakt säljavgift",
  外汇合约收入: "Valutaterminskontrakt inkomst",
  理财购买: "Förmögenhetsförvaltning köp",
  VIP理财日收益: "VIP förmögenhetsförvaltning daglig avkastning",
  VIP理财隔夜利息: "VIP förmögenhetsförvaltning övernattningsränta",
  VIP本金返还: "VIP återbetalning av kapitalbelopp",
  VIP彩金发放: "VIP bonus utbetalning",
  VIP彩金抵扣: "VIP bonus avdrag",
  隔夜利息: "Övernattningsränta",
  设置资产密码: "Ange tillgångslösenord",

  锁仓挖矿: "Låst mining",
  一站式理财服务: "Allt-i-ett finansiell tjänst",
  产品: "Produkter",
  客服中心: "Kundtjänstcenter",
  贷款: "Lån",
  挖矿赚不停: "Fortsatt intjäning från mining",
  "锁仓挖矿是通过将USDT (USD:1USDT=1USD) 托管给平台超算力矿机，在平台矿池中进行挖矿收益。":
    "Låst mining innebär att USDT (USD:1USDT=1USD) deponeras i plattformens högpresterande miningmaskiner för att generera avkastning i plattformens miningpool.",
  产品优势: "Produktfördelar",
  随存随取: "Sätt in och ta ut när som helst",
  锁仓周期: "Låsningsperiod",
  每日下发: "Daglig utbetalning",
  随机空投: "Slumpmässig airdrop",
  "100%资金安全保障": "100% säkerhet för medel",
  "100%节假日收益不间断": "100% kontinuerlig avkastning även på helgdagar",
  成功锁仓后当天产出: "Avkastning börjar samma dag efter lyckad låsning",
  关于违约金: "Om straffavgift",
  "若您希望转出未到期的本金,则会产生违约金,违约金=违约结算比例*剩余天数*锁仓金额.":
    "Om du tar ut kapital innan löptidens slut tas en straffavgift ut. Straffavgift = straffsats × återstående dagar × låst belopp.",
  "举例:此锁仓挖矿的违约结算比例为5%,剩余3天到期,锁仓金额为10000U《USDT/USD》,则违约金=5%*3*10000=1500U,实际退回本金为15000U-1500U":
    "Exempel: straffsatsen är 5 %, 3 dagar återstår och det låsta beloppet är 10000U (USDT/USD). Straffavgift = 5%×3×10000=1500U, faktiskt återbetalt kapital är 15000U-1500U.",
  收益计算: "Avkastningsberäkning",
  "平台有多种锁仓挖矿理财产品供使用者选择,收益计算如下,举例:":
    "Plattformen erbjuder flera finansiella produkter för låst mining. Avkastningsberäkningen är som följer, exempelvis:",
  "会员在平台锁仓10000U(USDT,USD),如选择了周期为7天,日产出为锁仓金额的0.7%~1.8%的理财产品,则每天产出如下":
    "Om en användare låser 10000U (USDT, USD) och väljer ett 7-dagars produkt med daglig avkastning på 0,7%~1,8% av låst belopp, blir daglig avkastning enligt följande:",
  "最低:10000Ux0.7%=70U;": "Minimum: 10000U×0,7%=70U;",
  "最高:10000Ux1.8%=180U;": "Maximum: 10000U×1,8%=180U;",
  "即7天后可获得490U~1260U的收益,收益每日下发,锁仓本金到期后,自动转入您的资金账户.":
    "Efter 7 dagar kan en avkastning på 490U~1260U erhållas. Avkastningen betalas ut dagligen och kapitalet överförs automatiskt till ditt konto vid förfall.",
  正在托管的资金: "Förvaltade medel",
  签到: "Daglig incheckning",
  锁仓订单: "Låsta order",
  预计今日收益: "Beräknad dagens avkastning",
  累计收益: "Ackumulerad avkastning",
  托管中的订单: "Order under förvaltning",
  单笔最少: "Minsta orderbelopp",
  单笔最多: "Maximalt orderbelopp",
  日收益率: "Daglig avkastning",
  说明: "Beskrivning",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出<br>3.当天的收益会统一在次日GMT+8时间00:00-00:10内派发.":
    "1. Statistik baseras på GMT+8-tid<br>2. Daglig avkastning beräknas från alla avräknade order mellan 00:00–23:59 GMT+8<br>3. Avkastning betalas ut nästa dag mellan 00:00–00:10 GMT+8.",
  知道了: "Jag förstår",
  锁仓: "Lås",
  派息时间: "Utbetalningstid",
  每日: "Dagligen",
  托管资金: "Förvaltade medel",
  到期返回: "Återbetalning vid förfall",
  提前赎回: "Förtida inlösen",
  预计收益: "Beräknad avkastning",
  认购: "Teckning",
  热门: "Populärt",
  数字货币: "Kryptovalutor",
  贵金属: "Ädelmetaller",
  大宗商品: "Råvaror",
  持仓明细: "Positionsdetaljer",
  历史明细: "Historik",
  当前价: "Aktuellt pris",
  "↑买涨": "↑ Köp uppgång",
  "↓买跌": "↓ Köp nedgång",
  显示全部: "Visa alla",
  买入金额: "Köpesumma",
  方向: "Riktning",
  收益: "Vinst",
  预期收益: "Förväntad vinst",
  估用保证金: "Beräknad marginal",
  确认下单: "Bekräfta order",
  锁定: "Låst",
  账户总资产: "Totala tillgångar",
  明细: "Detaljer",
  今日收益: "Dagens vinst",
  仓位保证金: "Positionsmarginal",
  持有仓位: "Öppna positioner",
  "锁定金额=所有锁仓挖矿中未完成订单的金额总和":
    "Låst belopp = summan av alla ofullständiga låsta mining-order",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出":
    "1. Statistik baseras på GMT+8<br>2. Daglig avkastning beräknas från avräknade order",
  充值方式: "Insättningsmetod",
  银行汇款: "Banköverföring",
  "银行汇款请联系客服进行操作!": "Kontakta kundtjänst för banköverföring!",
  提款方式: "Uttagsmetod",
  "银行提款请联系客服进行操作!": "Kontakta kundtjänst för bankuttag!",
  资金明细: "Fonddetaljer",
  提现记录: "Uttagshistorik",
  拒绝: "Avvisad",
  通过: "Godkänd",
  拒绝原因: "Avslagsorsak",

  消息公告: "Meddelanden",
  订单: "Beställningar",
  个人中心: "Personligt centrum",
  "未到期赎回需支付一定的违约金!":
    "Vid förtida inlösen måste en straffavgift betalas.",

  请输入区号: "Ange riktnummer",
  "请选择国家/地区": "Välj land/region",
  今日开盘: "Dagens öppning",
  昨日收盘: "Gårdagens stängning",

  实名认证即送: "Få det straks efter identitetsverifiering",
  立即认证: "Verifiera nu",
  新用户礼包: "Presentpaket för nya användare",
  完成新人任务领取: "Slutför uppgifterna för nya användare för att hämta",
  认证: "Verifiera",
  时间周期: "Tidsperiod",
  支付金额: "Betalningsbelopp",
  已平仓: "Stängd",
  "MGBX 新用户欢迎礼包：每位用户最多可获得":
    "MGBX välkomstpaket för nya användare: varje användare kan få högst",
  我已经阅读并同意: "Jag har läst och godkänner",
  隐私政策: "Integritetspolicy",

  放弃奖励离开: "Avstå från belöningen och lämna",
  继续注册: "Fortsätt registreringen",
  分钟: "Minuter",

  "请先勾选隐私政策!": "Vänligen läs igenom integritetspolicyn först!",

  添加其他到自选: "Lägg till andra i bevakningslistan",

  充值最高可得: "Fyll på och få upp till 30 000 dollar.",

  请输入格式正确的手机号: "Ange ett giltigt mobilnummer.",

  收起: "Collapse",
  上传截图: "Upload screenshot",
  "*充值成功后必须上传充值截图，否则将视为无效存款。": "*After a successful recharge, you must upload the recharge screenshot; otherwise the deposit will be invalid.",
};
// 瑞典



// WEBPACK FOOTER //
// ./src/lang/rd.js